export default __webpack_public_path__ + "static/media/ana_maria_lyon_ajuste.ef9dd94e.jpg";